import React, { useState } from "react";
import { MapPin, Phone, Mail, ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [openSection, setOpenSection] = useState(null);
  const toggle = (section) => setOpenSection(openSection === section ? null : section);

  const sections = [
    {
      id: "contact", title: "Contact Us",
      content: (
        <div className="space-y-2.5 text-sm text-gray-600">
          <p className="flex items-start gap-2"><MapPin size={16} className="text-blue-700 mt-0.5 flex-shrink-0" />Constituency Bursary Office, Igembe South</p>
          <p className="flex items-center gap-2"><Phone size={16} className="text-blue-700 flex-shrink-0" />+254 700 000 000</p>
          <p className="flex items-center gap-2"><Mail size={16} className="text-blue-700 flex-shrink-0" /><a href="mailto:bursary@igembesouth.go.ke" className="hover:text-blue-700 hover:underline transition-colors">bursary@igembesouth.go.ke</a></p>
        </div>
      ),
    },
    {
      id: "links", title: "Quick Links",
      content: (
        <ul className="space-y-2 text-sm text-gray-600">
          {[{ to: "/", label: "Home" }, { to: "/student-dashboard", label: "Apply for Bursary" }, { to: "/login", label: "Check Status" }, { to: "/eligibility", label: "Eligibility" }, { to: "/support", label: "Support" }].map(({ to, label }) => (
            <li key={label}><Link to={to} className="hover:text-blue-700 hover:underline transition-colors">{label}</Link></li>
          ))}
        </ul>
      ),
    },
    {
      id: "info", title: "Information",
      content: (
        <ul className="space-y-2 text-sm text-gray-600">
          <li><a href="https://www.iebc.or.ke/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-700 hover:underline transition-colors">Electoral & Constituency Info</a></li>
          <li><a href="https://www.education.go.ke/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-700 hover:underline transition-colors">Ministry of Education</a></li>
          <li><a href="https://www.helb.co.ke/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-700 hover:underline transition-colors">HELB Guidelines</a></li>
          <li><Link to="/support" className="hover:text-blue-700 hover:underline transition-colors">Bursary Regulations</Link></li>
        </ul>
      ),
    },
    {
      id: "about", title: "About the Bursary",
      content: (
        <ul className="space-y-2 text-sm text-gray-600">
          {[{ to: "/about", label: "Our Story" }, { to: "/leadership", label: "Leadership" }, { to: "/annual-reports", label: "Annual Reports" }, { to: "/data-privacy", label: "Data Privacy & Policies" }].map(({ to, label }) => (
            <li key={label}><Link to={to} className="hover:text-blue-700 hover:underline transition-colors">{label}</Link></li>
          ))}
        </ul>
      ),
    },
  ];

  return (
    <footer className="bg-gray-100 text-gray-700 mt-10 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-8">
        {sections.map((section) => (
          <div key={section.id}>
            <button
              className="w-full flex justify-between items-center md:cursor-default font-semibold text-blue-700 md:text-base mb-3 md:mb-4 text-left"
              onClick={() => toggle(section.id)}
            >
              {section.title}
              <ChevronDown size={16} className={`md:hidden transition-transform duration-200 ${openSection === section.id ? "rotate-180" : ""}`} />
            </button>
            <div className={`overflow-hidden transition-all duration-300 ${openSection === section.id ? "max-h-96" : "max-h-0"} md:max-h-full md:overflow-visible`}>
              {section.content}
            </div>
          </div>
        ))}
      </div>
      <div className="border-t border-blue-800 py-4 text-center text-sm text-white bg-blue-700 px-4">
        &copy; {new Date().getFullYear()} Igembe South Constituency Bursary System. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;